@if(middledata?.uid === "HomepageInnovativeComponent"){
<div class="homepage_allproductContent" id="homepage_allproductContent">
    <div class="homepage_prodwrapper">
        <div class="allprodheading" [innerHTML]=middledata?.h2content></div>
        <div class="allprodsubheading" [innerHTML]="middledata?.content"> </div>
    </div>
</div>
}

@if(middledata?.uid === "AllProductInnovativeComponent"){
<div class="allproductContent" id="allproductContent">
    <div class="allproductwrapper">
        <div class="allproductHeader" [innerHTML]=middledata?.content></div>
    </div>
</div>
}
@if(middledata?.uid ==="planning-ahead-component"){
    <section class="aboutpage_top" id="aboutpage_top">
    <div class="aboutpagepara_container" id="aboutpagepara_container">
        <div class="aboutpara" [innerHTML]=middledata?.content></div>
        <div class="aboutlogin">
            <button class="aboutloginbtn" [routerLink]="'/homepage'">
                <span class="aboutloginbtn_text" [innerHTML]=middledata?.h2content></span>
                <img alt="Next screen" src="../../../app/../assets/images/blackarrow.png" class="loginbtn-arrow">
            </button>
        </div>
    </div>
    </section>
}
@if (middledata?.uid !== "AllProductInnovativeComponent" && middledata?.uid !== "HomepageInnovativeComponent" && middledata?.uid !=="planning-ahead-component"){
<div class="col-xs-12 docnumberbox" id="home_planningcontent">
    <div class="col-xs-12 home_topfirst">
        <div class="col-xs-12 col-md-6 docleftUK" id="home_planningleftcontent" [innerHTML]="middledata?.content">
        </div>
        <div class="col-sm-12 col-md-6" id="home_planningrightcontent">
            <div class="col-sm-12" id="home_planningrighttext" [innerHTML]=middledata?.h2content></div>
            <div class="col-sm-12" id="home_planninglearn" [innerHTML]=middledata?.paragraphcontent appRouterlinkinterceptor></div>
            <div class="col-sm-12 margin-T20" id="home_planningrighttext">{{middledata?.bottomContent}}</div>
        </div>
    </div>
    <div class="col-xs-12 docnumberUk home_planningcontent_jobbag">{{middledata?.jobBagContent}}</div>
</div>
}